import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowRotateClockwise: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowRotateClockwise"><Path d="M19 7.1988C17.0297 4.87481 15.041 3.5 11.9858 3.5C7.29142 3.5 3.48584 7.30558 3.48584 12C3.48584 16.6944 7.29142 20.5 11.9858 20.5C15.6868 20.5 18.8353 18.1347 20.0022 14.8333" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round"/><Path d="M19.5 3.75V7.75H15.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowRotateClockwise;
